import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FiCheck } from 'react-icons/fi';

export default function SubscribeSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="max-w-md w-full p-6 text-center">
        <div className="w-16 h-16 bg-success text-success-content rounded-full flex items-center justify-center mx-auto mb-6">
          <FiCheck className="w-8 h-8" />
        </div>
        
        <h1 className="text-3xl font-bold mb-2">
          {t('payment.checkout.success.title')}
        </h1>
        
        <p className="text-base-content/70 mb-8">
          {t('payment.checkout.success.message')}
        </p>

        <button 
          onClick={() => navigate('/learn')}
          className="btn btn-primary w-full"
        >
          {t('payment.checkout.success.button')}
        </button>
      </div>
    </div>
  );
} 